(() => {
  const leavingClass = 'mega-menu-leaving';
  const exitDuration = 700;

  const init = () => {
    if (!window.matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)').matches) return;

    const nav = document.getElementById('AccessibleNav');
    if (!nav || nav.dataset.lbrMegaMenuExitReady === 'true') return;

    nav.dataset.lbrMegaMenuExitReady = 'true';
    const exitTimers = new WeakMap();

    const cancelExit = menu => {
      window.clearTimeout(exitTimers.get(menu));
      menu.classList.remove(leavingClass);
    };

    const startExit = menu => {
      if (!menu || menu.classList.contains(leavingClass)) return;

      menu.classList.add(leavingClass);
      exitTimers.set(menu, window.setTimeout(() => {
        menu.classList.remove(leavingClass);
        exitTimers.delete(menu);
      }, exitDuration));
    };

    // Run before the theme's bubbling handler removes nav-hover from siblings.
    nav.addEventListener('mouseover', event => {
      const nextItem = event.target.closest('.site-nav > li');
      if (!nextItem || !nav.contains(nextItem)) return;

      nav.querySelectorAll('.mega-menu.nav-hover').forEach(menu => {
        if (menu === nextItem) {
          cancelExit(menu);
        } else {
          startExit(menu);
        }
      });
    }, true);

    nav.addEventListener('mouseleave', () => {
      nav.querySelectorAll('.mega-menu.nav-hover').forEach(startExit);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
